var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-senior-component"},[_c('senior-list',{attrs:{"list":_vm.seniorList,"item-click":_vm.itemClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }